/**
 * Shifts a UTC date to the provided timezone if available, and returns the computed date. The time of the computed
 * result is meaningless and should not be taken into account.
 * @param utcIsoDate
 * @param timeZone
 */
export function getLocalDate(
  utcIsoDate: string | null | undefined,
  timeZone: string | null | undefined,
): Date {
  const utcDate = utcIsoDate ? new Date(utcIsoDate) : new Date()

  if (timeZone) {
    return new Date(utcDate.toLocaleString('en-US', { timeZone }))
  }

  return utcDate
}
